import React from 'react';
import CardSection from '../../Shared/CardSection';
import Tooltip from '../../Shared/Tooltip';

const MedSupValuesSection = ({ model, portalSettings }) => {

    const {
        polType,
        productName,
        productType,
        plan,
        statusDesc,
        issueDate,
        termDate,
        qualType
    } = model.policyInfo;

    const coverageType = model?.policyInfo?.typeOfCoverage === 'MedSup' ? 'Medicare Supplement' : model?.policyInfo?.typeOfCoverage;

    const mode = model.policyInfo.mode;
    const premiumMap = {
        1: { label: 'Monthly Premium', value: model.policyInfo.monthlyPremium },
        3: { label: 'Quarterly Premium', value: model.policyInfo.quarterlyPremium },
        6: { label: 'Semi-Annual Premium', value: model.policyInfo.semiAnnualPremium },
        12: { label: 'Annual Premium', value: model.policyInfo.annualPremium }
    };

    const selectedPremium = premiumMap[mode] || { label: 'Unknown', value: 0 };

    // Build tooltip content with all *except* selected
    const tooltipContent = Object.entries(premiumMap)
        .filter(([key]) => parseInt(key) !== mode)
        .map(([_, info]) => `${info.label}: ${info.value}`)
        .join('\n');

    return (
        <div className="container container-section custom-width" id="values-container">

            {/* Top Row: Premium Card */}
            <div className="flex-row">
                <div className="policy-card small-card">
                    <div className="card">
                        <div className="card-body premium-card-body">
                            <div className="premium-header">
                                <h6>
                                    {selectedPremium.label}
                                    <Tooltip text={tooltipContent} />
                                </h6>
                            </div>

                            <h3 className="bold value">{selectedPremium.value}</h3>
                        </div>
                    </div>
                </div>
                {/*Removed per Taylor/Andelyn 2026/09/14*/}
                {/*<div className="policy-card small-card">*/}
                {/*    <div className="card">*/}
                {/*        <div className="card-body premium-card-body">*/}
                {/*            <div className="premium-header">*/}
                {/*                <h6>Total Premiums Paid</h6>*/}
                {/*            </div>*/}

                {/*            <h3 className="bold value">{model.policyInfo.premiumSumDisplay}</h3>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>

            {/* Second Row: Card Sections */}
            <div className="flex-row">
                <CardSection
                    title="Contract Details"
                    blocks={[
                        { label: "Plan:", value: model.policyInfo.productType + ' ' + model.policyInfo.idCardDesc },
                        { label: "Coverage Type:", value: coverageType },
                        { label: "Billing Method:", value: model.policyInfo.billingMethod },
                        { label: "Issue Date:", value: model.policyInfo.issueDate },
                        { label: "Paid To Date:", value: model.policyInfo.paidToDate }
                    ]}
                />
                <CardSection
                    title="Insured Info"
                    blocks={[
                        { label: "Name:", value: model.insured.displayName },
                        { label: "Age:", value: model.insured.age },
                        { label: "Gender:", value: model.policyInfo.sex },
                        { label: "Birthday:", value: model.policyInfo.birthDate },
                        { label: "Phone:", value: model.insured.phone },
                        { label: "Email:", value: model.insured.email },
                        { label: "Issue State:", value: model.policyInfo.issueState }
                    ]}
                />
            </div>
        </div>
    );
};

export default MedSupValuesSection;
